export const editCheck = 'edit';
export const newCheck = 'new';
export type NotificationTypes = 'edit' | 'new';



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/aux/notification-types.ts